var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournalSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 7.49297H12.675C10.7 7.49297 9.09165 5.88464 9.09165 3.90964V1.5013C9.09165 1.04297 8.71665 0.667969 8.25831 0.667969H4.72498C2.15831 0.667969 0.083313 2.33464 0.083313 5.30964V12.693C0.083313 15.668 2.15831 17.3346 4.72498 17.3346H11.275C13.8416 17.3346 15.9166 15.668 15.9166 12.693V8.3263C15.9166 7.86797 15.5416 7.49297 15.0833 7.49297Z",
    fill: "#075453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 0.842068C10.825 0.500401 10.2333 0.733735 10.2333 1.20873V4.11707C10.2333 5.33373 11.2667 6.34207 12.525 6.34207C13.3167 6.3504 14.4167 6.3504 15.3583 6.3504C15.8333 6.3504 16.0833 5.79207 15.75 5.45873C14.55 4.2504 12.4 2.0754 11.1667 0.842068Z",
    fill: "#075453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalSelected);
export default __webpack_public_path__ + "static/media/journalSelected.dd35b115eaacb8220c9bc65e7842c140.svg";
export { ForwardRef as ReactComponent };